import PropTypes from "prop-types";
import React, { Component } from "react";
import { FixedSizeGrid } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import AutoSizer from "react-virtualized-auto-sizer";
import AdminPageLayout from "../../../../components/FullPageLayout/AdminPageLayout";
import { Box } from "@mui/material";
import ArchiveRepositoryModal from "./ArchiveRepositoryModal";
import {
  fetchRepository,
  fetchRepositories,
  fetchRepositoryItems,
  clearItems
} from "../../../../redux/actions/repositoryActions";
import { connect } from "react-redux";
import RepositoryItemCard from "./RepositoryItemCard";
import { push } from "connected-react-router";
import { bindActionCreators } from "redux";
import ManageRepositoryHeaderActions from "./ManageRepositoryHeaderActions";
import {
  repositories,
  buildAddRepositoryItemRoute,
  buildAddRepositoryItemVersionRoute,
  buildManageRespositoryRoute,
  buildManageRepositoryItemRoute
} from "../../../../routes/AdminRoutes";
import { withTranslation } from "react-i18next";
import { makeGetEntities } from "../../../../redux/selectors/selectors";
import { sortBy } from "lodash";
import { Skeleton } from "@mui/material";
import { getDownloadTooltipText } from "../../../../utils/repositoryUtils";
import { activityTypes } from "../../../../constants";
import AddRepositoryItemVersionModal from "./AddRepositoryItemVersion/AddRepositoryItemVersionModal";

class ManageRepository extends Component {
  constructor(props) {
    super(props);
    this.state = {
      repositoryMeta: {},
      repository: null,
      items: [],
      itemPageSize: 50,
      selectedItem: null,
      archiveModalOpen: false,
      itemVersionModalOpen: false,
      filterValues: {
        search: ""
      }
    };
  }

  handleBackToRepositoryView = () => {
    this.props.push(repositories);
  };

  handleAddItemClick = () => {
    const { selectedItem } = this.state;
    const {
      push,
      match: {
        params: { repositoryId }
      }
    } = this.props;
    if (!selectedItem) {
      push(buildAddRepositoryItemRoute(repositoryId));
    } else {
      if (
        selectedItem.extendedItemType === activityTypes.quiz ||
        selectedItem.extendedItemType === activityTypes.survey ||
        selectedItem.extendedItemType === activityTypes.homework
      ) {
        this.setState({ itemVersionModalOpen: true });
      } else {
        push(buildAddRepositoryItemVersionRoute(repositoryId, selectedItem.id));
      }
    }
  };

  handleSelectRepositoryItem = selectedItem => {
    if (
      this.state.selectedItem &&
      this.state.selectedItem.id === selectedItem.id
    ) {
      this.setState({ selectedItem: null });
    } else {
      this.setState({ selectedItem });
    }
  };

  handleCloseAddItemVersionModal = itemId => {
    this.setState({ selectedItem: null });
    this.setState({ itemVersionModalOpen: false });
    const {
      match: {
        params: { repositoryId }
      }
    } = this.props;
    if (itemId) {
      this.props.push(buildManageRepositoryItemRoute(repositoryId, itemId));
    } else {
      this.props.push(buildManageRespositoryRoute(repositoryId));
    }
  };

  handleSetArchiveModalOpen = archiveModalOpen => {
    this.setState({ archiveModalOpen });
  };

  handleSearchItem = event => {
    console.log(event.target.value);
    this.setState(
      {
        filterValues: { ...this.state.filerValues, search: event.target.value }
      },
      () => {
        console.log(this.state.filterValues);
        clearItems();
        this.props.fetchRepositoryItems(
          this.state.repository.id,
          {
            page: {
              size: this.state.itemPageSize,
              number: this.state.itemPageNumber
            }
          },
          this.state.filterValues
        );
      }
    );
  };

  handleOpenRepositoryItem = repositoryItemId => {
    const {
      push,
      match: {
        params: { repositoryId }
      }
    } = this.props;
    push(buildManageRepositoryItemRoute(repositoryId, repositoryItemId));
  };

  handleDownload = () => {
    const item = this.state.selectedItem;
    if (item && item.downloadLink) {
      const link = document.createElement("a");
      link.href = item.downloadLink;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  uniqueCourseSectionNames = sections => {
    return [
      ...new Set(
        sections.map(section => {
          return section.title;
        })
      )
    ].join(", ");
  };

  isDownloadDisabled = () =>
    !this.state.selectedItem || !this.state.selectedItem.downloadLink;

  componentDidUpdate() {
    const { repositoryMeta, repository, items } = this.props;
    if (repositoryMeta && repositoryMeta !== this.state.repositoryMeta) {
      this.setState({ repositoryMeta });
    }
    if (repository && repository !== this.state.repository) {
      this.setState({ repository });
    }
    if (items && items !== this.state.items) {
      this.setState({ items: items });
    }
  }

  componentDidMount() {
    const { fetchRepository, clearItems } = this.props;
    const { repositoryId } = this.props.match.params;
    // Clearing the items in redux prevents a library without items from
    // showing the previous library's items.
    clearItems();
    fetchRepository(repositoryId);
  }

  numColumns(width) {
    return Math.floor(width / (280 + 16));
  }

  // Used to add "padding" between item cards.
  GUTTER_SIZE = 16;

  renderLoadingSpinner = key => {
    return !this.isItemLoaded(key) && key + 1 < this.state.items.length;
  };

  isItemLoaded = index => {
    return this.state.items && !!this.state.items[index];
  };

  loadMoreItems = (startIndex, stopIndex) => {
    const { fetchedItemPages } = this.props;
    const itemPageNumber = Math.floor(stopIndex / this.state.itemPageSize) + 1;
    if (fetchedItemPages.indexOf(itemPageNumber) !== -1) {
      // Waiting for a request in-flight so we don't start another.
      return null;
    }
    return this.props.fetchRepositoryItems(this.state.repository.id, {
      page: {
        size: this.state.itemPageSize,
        number: itemPageNumber
      }
    });
    // Clean up state after the request completes
  };

  RepositoryItem = ({ style, rowIndex, columnIndex, numColumns }) => {
    const { selectedItem } = this.state;
    const key = rowIndex * numColumns + columnIndex;
    if (!this.isItemLoaded(key)) {
      return (
        <div
          style={{
            ...style,
            left: style.left + this.GUTTER_SIZE / 2,
            top: style.top + this.GUTTER_SIZE,
            width: style.width - this.GUTTER_SIZE,
            height: style.height - this.GUTTER_SIZE
          }}
        >
          {this.renderLoadingSpinner(key) && (
            <Skeleton height="100%" variant="rectangular" />
          )}
        </div>
      );
    }
    const repositoryItem = this.state.items[key];

    return (
      repositoryItem && (
        <RepositoryItemCard
          style={{
            ...style,
            left: style.left + this.GUTTER_SIZE / 2,
            top: style.top + this.GUTTER_SIZE,
            width: style.width - this.GUTTER_SIZE,
            height: style.height - this.GUTTER_SIZE
          }}
          onSelectRepositoryItem={this.handleSelectRepositoryItem.bind(
            this,
            repositoryItem
          )}
          onOpenRepositoryItem={() =>
            this.handleOpenRepositoryItem(repositoryItem.id)
          }
          selected={selectedItem && repositoryItem.id === selectedItem.id}
          name={repositoryItem.name}
          description={repositoryItem.description}
          type={repositoryItem.contentType}
          creator={repositoryItem.creator ? repositoryItem.creator.name : ""}
          extendedType={repositoryItem.extendedItemType}
          latestVersion={repositoryItem.latestVersionNumber}
          lastUpdated={repositoryItem.lastModifiedDate}
          repositoryAccessType={
            repositoryItem.repository && repositoryItem.repository.accessType
          }
          courses={
            repositoryItem.courseTitles
              ? repositoryItem.courseTitles.join(", ")
              : ""
          }
        />
      )
    );
  };

  render() {
    const { repository, selectedItem } = this.state;
    const { t } = this.props;
    const isLibrary =
      repository && repository.contextType === "ContentRepository::Library";
    return repository ? (
      <AdminPageLayout
        title={repository.name}
        headerActions={
          <ManageRepositoryHeaderActions
            archiveDisabled={!selectedItem}
            downloadDisabled={this.isDownloadDisabled()}
            addItemDisabled={!isLibrary}
            onArchiveClick={() => this.handleSetArchiveModalOpen(true)}
            onAddItemClick={this.handleAddItemClick}
            onDownloadClick={this.handleDownload}
            downloadTooltipText={t(
              getDownloadTooltipText(
                !!selectedItem,
                selectedItem && selectedItem.downloadLink,
                selectedItem ? selectedItem.downloadRule : ""
              )
            )}
            handleSearchItem={this.handleSearchItem}
          />
        }
        onGoBackClick={this.handleBackToRepositoryView}
      >
        <Box mt={1} height={"100%"}>
          <AutoSizer>
            {({ height, width }) => (
              <InfiniteLoader
                isItemLoaded={this.isItemLoaded}
                itemCount={this.state.items.length}
                loadMoreItems={this.loadMoreItems}
                minimumBatchSize={this.state.itemPageSize}
                threshold={Math.floor(this.state.itemPageSize / 2)}
              >
                {({ onItemsRendered, ref }) => {
                  const numColumns = this.numColumns(width);
                  return (
                    <FixedSizeGrid
                      onItemsRendered={({
                        visibleRowStartIndex,
                        visibleRowStopIndex
                      }) =>
                        onItemsRendered({
                          visibleStartIndex: visibleRowStartIndex * numColumns,
                          visibleStopIndex: visibleRowStopIndex * numColumns
                        })
                      }
                      ref={ref}
                      rowCount={Math.ceil(this.state.items.length / numColumns)}
                      columnCount={numColumns}
                      rowHeight={212 + this.GUTTER_SIZE}
                      columnWidth={width / numColumns}
                      width={width}
                      height={height}
                      style={{ paddingBottom: 8 }}
                    >
                      {props =>
                        this.RepositoryItem({
                          ...props,
                          numColumns
                        })
                      }
                    </FixedSizeGrid>
                  );
                }}
              </InfiniteLoader>
            )}
          </AutoSizer>
        </Box>
        <ArchiveRepositoryModal
          open={this.state.archiveModalOpen}
          onOpenChange={this.handleSetArchiveModalOpen}
        />
        <AddRepositoryItemVersionModal
          open={this.state.itemVersionModalOpen}
          onClose={this.handleCloseAddItemVersionModal}
          existingItem={selectedItem}
          existingItemId={selectedItem ? selectedItem.id : null}
        />
      </AdminPageLayout>
    ) : null; //TODO: change to loading spinner
  }
}

const makeMapStateToProps = () => {
  const mapStateToProps = ({ repositoryState }, props) => {
    const repositoryId = props.match.params.repositoryId;
    let repositoryMeta = {};
    if (repositoryState.libraries && repositoryState.libraries[repositoryId]) {
      repositoryMeta = repositoryState.libraries[repositoryId].meta;
    }
    const selector = makeGetEntities();
    const repository = selector(repositoryState, {
      type: "libraries",
      id: repositoryId
    });
    let items = selector(repositoryState, {
      type: "items"
    });
    if (items && items.length > 0) {
      items = sortBy(items, item => item.name.toUpperCase());
    }
    return {
      repositoryMeta,
      repository,
      items: repositoryState.itemList,
      fetchedItemPages: repositoryState.fetchedItemPages
    };
  };
  return mapStateToProps;
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchRepository,
      fetchRepositories,
      fetchRepositoryItems,
      push,
      clearItems
    },
    dispatch
  );
}

export default withTranslation()(
  connect(makeMapStateToProps, mapDispatchToProps)(ManageRepository)
);

ManageRepository.propTypes = {
  /**
   * Called to fetch the repository data
   */
  fetchRepositories: PropTypes.func,
  fetchRepository: PropTypes.func,
  fetchRepositoryItems: PropTypes.func,
  clearItems: PropTypes.func,
  /**
   * The repository's items
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.any,
      imageSrc: PropTypes.any,
      associatedCourses: PropTypes.array,
      associatedFiles: PropTypes.array,
      creator: PropTypes.shape({
        name: PropTypes.string
      }),
      latestVersion: PropTypes.any,
      lastUpdated: PropTypes.string,
      createdDate: PropTypes.string,
      tags: PropTypes.arrayOf(PropTypes.string),
      file: PropTypes.any,
      active: PropTypes.bool,
      description: PropTypes.description,
      comments: PropTypes.string,
      events: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          creator: PropTypes.string,
          version: PropTypes.any,
          uploaded: PropTypes.string,
          comments: PropTypes.string
        })
      )
    })
  ),
  match: PropTypes.object,
  push: PropTypes.func,
  repository: PropTypes.object,
  repositoryMeta: PropTypes.object
};
